// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"556":"6cbbfeb8","623":"08a9c88f"}[chunkId] + ".chunk.css";
};